import { api } from "roboflex-thalamus-request-handler";
import { downloadFromArrayBuffer } from "@/utils/download";

const consultarProjetos = {
  async buscarProjetos(projetosOuPlanoAcao) {
    try {
      const response = await api.post(`${projetosOuPlanoAcao}/tarefas/status`);
      return response.data;
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error("Erro ao buscar projetos:", error);
      throw error;
    }
  },

  async baixarXML(projetosOuPlanoAcao) {
    const response = await api.post(
      `${projetosOuPlanoAcao}/tarefas/status`,
      { gerar: "xlsx" },
      { responseType: "arraybuffer" }
    );
    downloadFromArrayBuffer(response.data, `Relatório_${projetosOuPlanoAcao}.xlsx`);
  },
}

export default consultarProjetos;
